<template>
    <m-main-layout>
        <div class="page-content-main">
            <el-form
                :model="formData"
                status-icon
                :rules="rules"
                ref="form"
                label-width="auto"
                class="margin-top"
                style="width:500px;"
            >
							<el-form-item label="网站Logo" prop="site_logo">
								<head-img-upload v-model="formData.site_logo"></head-img-upload>
							</el-form-item>
                <el-form-item label="验证码有效时长" prop="sms_code_time">
                    <el-input type="text" v-model="formData.sms_code_time">
                        <template slot="append">分钟</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="是否开启VIP购买" prop="open_vip_buy">
                    <el-switch
                        v-model="formData.open_vip_buy"
                        active-color="#13ce66"
                        :active-value="1"
                        :inactive-value="0"
                        active-text="启用"
                        inactive-text="禁用">
                    </el-switch>
                </el-form-item>
                <el-form-item label="默认头像" prop="default_avatar">
                    <head-img-upload v-model="formData.default_avatar"></head-img-upload>
                </el-form-item>
                <el-divider content-position="left">企业信息设置</el-divider>
                <el-form-item label="客服二维码" prop="qq_service_qrcode">
                    <head-img-upload v-model="formData.qq_service_qrcode"></head-img-upload>
                </el-form-item>
                <el-form-item label="客服QQ号" prop="service_qq">
                    <el-input type="text" v-model="formData.service_qq"></el-input>
                </el-form-item>
                <el-form-item label="客服热线电话" prop="service_tel">
                    <el-input type="text" v-model="formData.service_tel"></el-input>
                </el-form-item>
                <el-form-item label="会员咨询电话" prop="vip_tel">
                    <el-input type="text" v-model="formData.vip_tel"></el-input>
                </el-form-item>
                <el-form-item label="会员咨询手机(同微信号)" prop="vip_weixin_tel">
                    <el-input type="text" v-model="formData.vip_weixin_tel"></el-input>
                </el-form-item>
                <el-form-item label="招标发布电话" prop="bids_push_tel">
                    <el-input type="text" v-model="formData.bids_push_tel"></el-input>
                </el-form-item>
                <el-form-item label="侧边悬停二维码" prop="side_qrcode">
                    <head-img-upload v-model="formData.side_qrcode"></head-img-upload>
                </el-form-item>
                <el-form-item label="悬停二维码宽度" prop="side_qrcode_width">
                    <el-input type="text" v-model="formData.side_qrcode_width">
                        <template slot="append">px</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="侧边悬浮下边距" prop="side_bottom">
                    <el-input type="text" v-model="formData.side_bottom">
                        <template slot="append">px</template>
                    </el-input>
                </el-form-item>
                <el-divider content-position="left">轮番设置</el-divider>
                <el-form-item label="开启招标公告顶部轮番" prop="open_notice_top_banner">
                    <el-switch
                        v-model="formData.open_notice_top_banner"
                        active-color="#13ce66"
                        :active-value="1"
                        :inactive-value="0"
                        active-text="开启"
                        inactive-text="隐藏">
                    </el-switch>
                </el-form-item>
                <el-form-item label="开启散单平台顶部轮番" prop="open_odd_top_banner">
                    <el-switch
                        v-model="formData.open_odd_top_banner"
                        active-color="#13ce66"
                        :active-value="1"
                        :inactive-value="0"
                        active-text="开启"
                        inactive-text="隐藏">
                    </el-switch>
                </el-form-item>
                <el-form-item label="开启仓储供给顶部轮番" prop="open_storage_top_banner">
                    <el-switch
                        v-model="formData.open_storage_top_banner"
                        active-color="#13ce66"
                        :active-value="1"
                        :inactive-value="0"
                        active-text="开启"
                        inactive-text="隐藏">
                    </el-switch>
                </el-form-item>
                <el-form-item label="开启设备采购顶部轮番" prop="open_device_top_banner">
                    <el-switch
                        v-model="formData.open_device_top_banner"
                        active-color="#13ce66"
                        :active-value="1"
                        :inactive-value="0"
                        active-text="开启"
                        inactive-text="隐藏">
                    </el-switch>
                </el-form-item>
                <el-divider content-position="left">页面设置</el-divider>
                <el-form-item label="网页地址信息" prop="page_footer">
                    <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="formData.page_footer" style="width: 500px;"/>
                </el-form-item>
                <el-divider content-position="left">第三方接口设置</el-divider>
                <el-form-item label="标讯绑定UID" prop="bid_bind_uid">
                    <el-input placeholder="请输入内容" v-model="formData.bid_bind_uid" style="width: 500px;"/>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm('form')">确定</el-button>
                    <el-button type="" @click="$router.back()">返回</el-button>
                </el-form-item>
            </el-form>
        </div>
    </m-main-layout>
</template>

<script>
export default {
    name: "add",
    data() {
        return {
            formData: {
							site_logo: "",
                sms_code_time: "",
                default_avatar:'',
                qq_service_qrcode:'',
                service_tel:'',
                vip_tel:'',
                bids_push_tel:'',
                open_vip_buy:0,
                service_qq:'',
                vip_weixin_tel:'',
                open_notice_top_banner:1,
                open_odd_top_banner:1,
                open_storage_top_banner:1,
                open_device_top_banner:1,
                side_qrcode:'',
                side_qrcode_width:0,
                side_bottom:0,
                page_footer:'',
                bid_bind_uid:''
            },
            rules: {
							site_logo: [{required: true, message:'网站logo必填'}],
                sms_code_time: [{required: true, validator: this.$utils.mustNumber,message:'请填写正确的时间'}],
                default_avatar: [{required: true, message:'默认头像必填'}],
                qq_service_qrcode: [{required: true, message:'客服二维码必填'}],
                service_tel: [{required: true, message:'客服电话必填'}],
                vip_tel: [{required: true, message:'会员咨询电话必填'}],
                bids_push_tel: [{required: true, message:'招标电话必填'}],
                service_qq: [{required: true, message:'客服QQ号必填'}],
                vip_weixin_tel: [{required: true, message:'会员咨询手机(微信号)必填'}],
                open_notice_top_banner: [{required: true, message:'招标公告轮番开关必填'}],
                open_odd_top_banner: [{required: true, message:'散单平台轮番开关必填'}],
                open_storage_top_banner: [{required: true, message:'仓储供给轮番开关必填'}],
                open_device_top_banner: [{required: true, message:'设备采购轮番开关必填'}],
                side_qrcode_width: [{required: true, message:'请填写正确的宽度，宽度必须是数字',validator: this.$utils.must09}],
                side_bottom: [{required: true, message:'请填写正确的下边距，下边距必须是数字',validator: this.$utils.must09}],
                page_footer: [{required: true, message:'网站底部信息必填'}],
                bid_bind_uid: [{required: true, message:'标讯绑定UID必填'}],
            }
        };
    },
    mounted() {
        this.getDetail();
    },
    methods: {
        submitForm(formName) {
            let _this = this;
            console.log(_this.formData);
            this.$refs[formName].validate(valid => {
                if (valid) {
                    _this.$http.httpPost({
                        url: "/SystemSetting/edit",
                        datas: {..._this.formData},
                        success: res => {
                            if (res === "ok") {
                                _this.$message.success("修改成功");
                            } else {
                                _this.$message.error("修改失败");
                            }
                        }
                    });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        getDetail() {
            let _this = this;

            let _skeys = [];

            for (let k in this.formData) {
                _skeys.push(k);
            }

            _this.$http.httpPost({
                url: "/SystemSetting/getSystem",
                datas: {skey: _skeys},
                success: res => {
                    _this.formData = res;
                    _this.formData.open_vip_buy = res.open_vip_buy ? parseInt(res.open_vip_buy) : 0;

                    _this.formData.open_notice_top_banner = res.open_notice_top_banner ? parseInt(res.open_notice_top_banner) : 0;

                    _this.formData.open_odd_top_banner = res.open_odd_top_banner ? parseInt(res.open_odd_top_banner) : 0;

                    _this.formData.open_storage_top_banner = res.open_storage_top_banner ? parseInt(res.open_storage_top_banner) : 0;

                    _this.formData.open_device_top_banner = res.open_device_top_banner ? parseInt(res.open_device_top_banner) : 0;
                }
            });
        }
    }
};
</script>
